// @flow

import type { DispatchType, GetStateType } from '../types/redux';
import type { LineType } from '../types/entities';
import type { ActionType } from '../types/actions';

// type DispatchType = (_: { type: string }) => void;
// type GetStateType = () => any;

export const CREATE_LINE = 'CREATE_LINE';
export const UPDATE_LINE = 'UPDATE_LINE';
export const DELETE_LINE = 'DELETE_LINE';
export const REORDER_LINES = 'REORDER_LINES';

export function createLine(obj: LineType, index?: number): ActionType {
  return function (dispatch: DispatchType, getState: GetStateType) {
    const id = Math.max(0, ...getState().song.lines.allIds) + 1;
    return dispatch({
      type: CREATE_LINE,
      obj: { ...obj, id },
      index,
    });
  };
}

export function updateLine(obj: LineType): { type: 'UPDATE_LINE', obj: LineType } {
  return { type: UPDATE_LINE, obj };
}

export function deleteLine(id: number): { type: 'DELETE_LINE', id: number } {
  return { type: DELETE_LINE, id };
}

export function reorderLines(allIds: Array<number>): { type: 'REORDER_LINES', allIds: Array<number> } {
  return { type: REORDER_LINES, allIds };
}



// WEBPACK FOOTER //
// ./src/actions/line.js